import HolographicCard from '@/components/base/HolographicCard';

export default function WhitePapersSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const whitepapers = [
    {
      id: 1,
      icon: 'ri-brain-line',
      title: 'The Science',
      description: 'Foundational research on deterministic intelligence and symbolic cognition architectures.',
    },
  ];

  return (
    <section id="whitepapers" className="py-20 relative">
      {/* Background elements */}
      <div className="absolute top-20 left-20 w-40 h-40 bg-gradient-to-br from-purple-400/5 to-transparent rounded-full blur-2xl"></div>
      <div className="absolute bottom-20 right-20 w-32 h-32 bg-gradient-to-br from-cyan-400/5 to-transparent rounded-full blur-2xl"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold mb-6 font-orbitron">
              <span
                className="text-white"
                style={{
                  textShadow: `
                    -1px -1px 0 #8b5cf6,
                    1px -1px 0 #8b5cf6,
                    -1px 1px 0 #8b5cf6,
                    1px 1px 0 #8b5cf6,
                    -2px -2px 0 #06b6d4,
                    2px -2px 0 #06b6d4,
                    -2px 2px 0 #06b6d4,
                    2px 2px 0 #06b6d4
                  `
                }}
              >
                The Science
              </span>
            </h2>
          </div>

          {/* White Paper Cards */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <HolographicCard className="p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-400/20 to-cyan-600/20 rounded-full flex items-center justify-center border border-cyan-400/30 mx-auto mb-6">
                <i className="ri-file-text-line text-cyan-400 text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">
                DAHA Framework
              </h3>
              <p className="text-white/70 leading-relaxed">
                Deterministic-Adaptive Hybrid Architecture. The governance framework that separates identity from memory, enforces deterministic rules on adaptive reasoning, and makes AI behavior auditable and portable.
              </p>
            </HolographicCard>

            <HolographicCard className="p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-400/20 to-purple-600/20 rounded-full flex items-center justify-center border border-purple-400/30 mx-auto mb-6">
                <i className="ri-cpu-line text-purple-400 text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">
                CausOS Runtime
              </h3>
              <p className="text-white/70 leading-relaxed">
                Governed phase-dispatch engine. Every interaction passes through the same deterministic 10-phase execution sequence. Auditable, repeatable, and domain-agnostic by design. CausOS powers both GenesisOS agents and Precursor forecasts.
              </p>
            </HolographicCard>

            <HolographicCard className="p-8 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-pink-400/20 to-pink-600/20 rounded-full flex items-center justify-center border border-pink-400/30 mx-auto mb-6">
                <i className="ri-robot-line text-pink-400 text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">
                Genesis Agents
              </h3>
              <p className="text-white/70 leading-relaxed">
                A new class of lifecycle AI defined by six structural properties: compiled identity, governed memory, deterministic governance, persistent lifecycle, auditable traces, and portable identity.
              </p>
            </HolographicCard>
          </div>

          {/* Access Information */}
          <div className="text-center">
            <p className="text-white/80 text-lg leading-relaxed mb-8 max-w-4xl mx-auto">
              Built from first principles. Validated in production. Read the original technical disclosures that started it all.
            </p>
            
            <button
              onClick={scrollToContact}
              className="whitespace-nowrap px-8 py-4 bg-gradient-to-r from-cyan-400 to-purple-500 text-white font-semibold rounded-lg hover:shadow-lg hover:shadow-cyan-400/25 transition-all duration-300 cursor-pointer"
            >
              Explore Our Research
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
